import React, { Component } from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';
import { ChromePicker } from 'react-color'

import { changePopupStyle, changeMapData } from '../actions/index';
import { selectPopupEditGeometry } from '../actions/actions_map';

class MapModalComponent extends Component {

    constructor(props) {
      super(props);
      this.state = {
        popupTip : true,
        backgroundColorPopup : false,
        backgroundColor : '',
        borderColorPopup : false,
        borderColor : '',
        roundedCorners : false
      }
    }

    componentDidMount() {
      if($('.wp-mapbox-gl-js-modal-content-editor .wp_mapbox_gl_js_editor_content_container').length) {} else {
        $('.wp_mapbox_gl_js_editor_content_container').appendTo('.wp-mapbox-gl-js-modal-content-editor');
      }
    }

    componentWillReceiveProps(nextProps) {
      if(this.props.mapActions.popupEditGeometry!==nextProps.mapActions.popupEditGeometry) {
        var content = '';
        this.props.mapObject.mapData.forEach(function(feature) {
          if(feature.id===nextProps.mapActions.popupEditGeometry) {
            content = feature.properties.description;
          }
        });
        $('#wp_mapbox_gl_js_editor_content_ifr').contents().find('#tinymce').html(content);
        $('#wp_mapbox_gl_js_editor_content_ifr').height(window.innerHeight-500);
      }
    }

    saveDescription(e) {
      e.preventDefault();
      var allFeatures = [];
      this.props.mapObject.mapData.forEach(function(feature) {
        var thisFeature = JSON.parse(JSON.stringify(feature));
        if(thisFeature.id===this.props.mapActions.popupEditGeometry) {
          console.log($('#wp_mapbox_gl_js_editor_content_ifr').contents().find('#tinymce').html());
          thisFeature.properties.description = $('#wp_mapbox_gl_js_editor_content_ifr').contents().find('#tinymce').html();
        }
        allFeatures.push(thisFeature);
      }.bind(this))
      this.props.dispatch(changeMapData(allFeatures));
      this.props.dispatch(changePopupStyle({
        popupTip : this.state.popupTip,
        backgroundColor : this.state.backgroundColor,
        borderColor : this.state.borderColor,
        roundedCorners : this.state.roundedCorners
      }));
      this.props.dispatch(selectPopupEditGeometry(false));
    }

    leave(e) {
      e.preventDefault();
      this.props.dispatch(selectPopupEditGeometry(false));
    }

    render() {

      const popover = {
        position: 'absolute',
        zIndex: 10000,
        marginTop: '-250px'
      }

      const cover = {
        position: 'fixed',
        top: '0px',
        right: '0px',
        bottom: '0px',
        left: '0px',
      }

      return (
        <div className="wp-mapbox-gl-js-modal-background" style={this.props.active ? {display:'block'} : {display: 'none'}}>
          <div className="wp-mapbox-gl-js-modal-content">
            <h3>Popup content</h3>
            <div className="wp-mapbox-gl-js-modal-content-editor"></div>
            {/*<div className="wp-mapbox-gl-js-modal-options">
              <p><strong>Popup Styling</strong></p>
              <input checked={this.state.popupTip} type="checkbox" /> Show popup tip <br />
              <input checked={this.state.roundedCorners} onChange={(e) => this.setState({roundedCorners:e.target.checked})} type="checkbox" /> Rounded Corners

              { this.state.backgroundColorPopup ? <div style={ popover }>
                <div style={ cover } onClick={ () => this.setState({backgroundColorPopup:false}) }/>
                <ChromePicker color={ this.state.backgroundColor } onChange={(e) => this.setState({backgroundColor:e.hex})} /> Background Color
              </div> : null }
              <button className="button" onClick={ (e) => { e.preventDefault(); this.setState({backgroundColorPopup:true}) } }>Background Color</button>

              { this.state.borderColorPopup ? <div style={ popover }>
                <div style={ cover } onClick={ () => this.setState({borderColorPopup:false}) }/>
                <ChromePicker color={ this.state.borderColor } onChange={(e) => this.setState({borderColor:e.hex})} /> Border Color
              </div> : null }
              <button className="button" onClick={ (e) => { e.preventDefault(); this.setState({borderColorPopup:true}) } }>Border Color</button>

            </div>
            */}
            <div className="wp-mapbox-gl-js-modal-buttons">
              <button className="button" onClick={this.leave.bind(this)}>Cancel</button>
              <button className="button" onClick={this.saveDescription.bind(this)}>Save</button>
            </div>
          </div>
        </div>
      )
    }
}

const mapStateToProps = (state,ownProps) => {
  // console.log(ownProps);
  return {
    mapObject : state.mapObject,
    mapActions : state.mapActions,
    active : ownProps.active
  }
}

const MapModal = connect(mapStateToProps)(MapModalComponent)

export default MapModal;



// WEBPACK FOOTER //
// ./src/components/MapModal.js